import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';

export const useDeletePlantAnalysis = () => {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation({
		mutationFn: async (id: string) => {
			try {
				return (await api.delete(`/plant-analysis/delete/${id}`, {
					params: { forBinding },
				})).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao deletar análise foliar');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['plantAnalysis'] });
		},
		onError: (error) =>
			console.error(
				'Erro ao deletar análise foliar:',
				getApiErrorMessage(error, 'Erro ao deletar análise foliar')
			),
	});
};
